import React from "react";
import Multimedia from "../components/multimedia/multimedia";
import { useParams } from 'react-router-dom';

export default function MultimediaRouter() {
  const { id } = useParams();
  return <Multimedia id = {id} />;
}
